import React from "react";
import { FleetrifyModal } from "../../Modal/modal";
import { FleetrifyButton } from "../../Button/customButton";
import { useLogoutControllers } from "../../../controllers/useLogoutController";

const LogoutModal = ({
  isModalOpen,
  setIsModalOpen,
}: {
  isModalOpen: boolean;
  setIsModalOpen: (param: boolean) => void;
}) => {
  const { isLoading, handleLogout } = useLogoutControllers({
    onClose: () => setIsModalOpen(false),
  });

  return (
    <FleetrifyModal
      isOpen={isModalOpen}
      onClose={() => setIsModalOpen(false)}
      title="Logout"
      className="h-fit"
    >
      <p className="text-sm text-gray-600 mb-6 p-4">
        Are you sure you want to logout?
      </p>
      <div className="flex gap-4 justify-end items-center p-3">
        <FleetrifyButton
          onClick={() => setIsModalOpen(false)}
          className="px-4 py-2 rounded-md text-sm hover:bg-red-200 text-black hover:text-white border-black"
          variant="outline"
        >
          Cancel
        </FleetrifyButton>
        <FleetrifyButton
          onClick={handleLogout}
          className="px-4 py-2 rounded-md text-sm bg-red-500 text-white hover:bg-red-600"
          loading={isLoading}
        >
          Logout
        </FleetrifyButton>
      </div>
    </FleetrifyModal>
  );
};

export default LogoutModal;
